export default {
  methods: {
    async onDetil() {
      this.$set(this, 'formulir', {});

      await this.getProfil();

      this.$set(this.formulir, 'component', 'PenjadwalanKandidat');
      this.$set(this.formulir, 'tipe', 'detil');
      this.$set(this.formulir, 'info', Object.assign({}, this.pspSimulasi, this.detail.meta));
      this.$set(this.formulir, 'isPreview', true);
      this.$refs.dialog.open();

      this.$nextTick(() => {
        this.$refs.jadwal.reset();
        this.$set(this.formulir, 'title', 'Detil Jadwal Simulasi Wawancara');
      });
    },

    onKonfirmasi(value) {
      if (this.isTutup) {
        const msg = `<p class="title mb-2">Mohon maaf! anda telah melewati batas waktu konfirmasi yang telah ditentukan</p>`;
        this.$info(msg, `Konfirmasi tidak dapat dilakukan`, {
          tipe: 'warning',
          data: '',
        });
        return;
      }

      const id = this.$getDeepObj(this.pspProfil, 'psp_profil_id');
      const gelombang = this.$getDeepObj(this.pspProfil, 'gelombang');
      this.$refs.notifjadwal.open().then(() => {
        this.updateKonfirm({ id: id, params: { is_setuju_jadwal: value, gelombang: gelombang } }).then(() => {
          this.$success('Berhasil konfirmasi jadwal, silahkan menunggu sesi simulasi melatih dimulai');
          this.getPreferensi(true);
        });
      });
    },

    onUbahSap() {
      this.$set(this.formulir, 'component', 'FormSap');
      this.$set(this.formulir, 'title', 'Ubah SAP (Satuan Acara Pelatihan)');

      const init = { ...this.fileSap };

      this.$refs.dialog.open();

      this.$nextTick(() => {
        this.$refs.jadwal.reset();
        this.$set(this.formulir, 'init', init);
      });
    },

    nextStep(item) {
      switch (item.value) {
        case 1:
          this.fetchRpp().then(() => {
            this.step++;
          });
          break;
      }
    },

    async getProfil() {
      const resp = await this.fetchProfil({ id: this.$getDeepObj(this.pspProfil, 'psp_profil_id') });
      this.detail = Object.assign({}, resp.data, resp.meta);
      this.fileSap = this.$getDeepObj(this, 'detail.psp_profil_sap.data') || {};
      return Promise.resolve(resp);
    },

    setSap(value) {
      const isUnggahSap = (value && value.psp_profil_sap && value.psp_profil_sap.data) || {};
      if (Object.keys(isUnggahSap).length > 0) {
        this.$set(this, 'step', 2);
      }
    },

    onCall(item) {
      const url = `https://wa.me/62${Number(item)}`;
      window.open(url, '_blank');
    },

    onSave() {
      const item = this.$refs.jadwal.getValue();
      const validate = this.$refs.jadwal.validate();
      let form = item?.form ?? {};
      const formData = new FormData();

      if (!validate) {
        this.$refs.dialog.loading = false;
        return;
      }

      Object.keys(form).forEach((key) => {
        if (key === 'file_sap') {
          if (typeof form[key] !== 'string') {
            formData.append(key, form[key]);
          }
        } else {
          formData.append(key, form[key]);
        }
      });

      this.konfirmasiSap({ id: this.$getDeepObj(this.pspProfil, 'psp_profil_id'), params: formData })
        .then(() => {
          this.$success('File Sap berhasil di perbarui');
          this.getPreferensi(true);
          this.getProfil();
          this.$refs.dialog.close();
        })
        .catch(() => {
          this.$refs.dialog.loading = false;
        });
    },
  },
};
